import { useCallback, useEffect, useRef, useState } from 'react'

import { sanitizeSupportDistribution } from './supportLaunchContext'
import { SupportDistributionSuggestion } from './supportScreenContext'

/** Only the latest selected source read may publish support context. */
export default function useChannelMappingSupport(channelCode: string) {
  const generation = useRef(0)
  const publishedGeneration = useRef(-1)
  const currentChannel = useRef(channelCode)
  if (currentChannel.current !== channelCode) {
    generation.current++
    currentChannel.current = channelCode
  }
  const [record, setRecord] = useState<SupportDistributionSuggestion>()
  const clear = useCallback(() => {
    generation.current++
    setRecord(undefined)
  }, [])
  useEffect(
    () => () => {
      generation.current++
    },
    []
  )
  const begin = useCallback(() => {
    const request = ++generation.current
    setRecord(undefined)
    return (source?: {
      AdotelCode: string
      AdotelName: string
      ChannelCode?: string
    }) => {
      if (
        request !== generation.current ||
        currentChannel.current !== channelCode
      )
        return
      generation.current++
      publishedGeneration.current = generation.current
      setRecord(
        sanitizeSupportDistribution([
          {
            refType: 'CHANNEL_MAPPING',
            propertyCode: source?.AdotelCode,
            channelCode,
            label: source?.AdotelName
          }
        ])[0]
      )
    }
  }, [channelCode])
  return {
    record:
      publishedGeneration.current === generation.current &&
      record?.refType === 'CHANNEL_MAPPING' &&
      record.channelCode === channelCode
        ? record
        : undefined,
    begin,
    clear
  }
}
